import { Component, Inject, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Session} from 'src/app/interfaces/session-data';
import gsap from 'gsap';
import {PaymentService} from '../../../services/payment/payment.service';
import {DOCUMENT} from '@angular/common';
import {TransactionStatus} from '../../../interfaces/payment-option';
import {environment} from 'src/environments/environment';
import {GetPostbackFormDataResponse} from '../../../interfaces/PostbackFormData/GetPostbackFormDataResponse';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';

export interface Error {
  error: string;
  errorDescription: string;
  status?: number;
}

export interface TransactionRef {
  ref: string;
}

@Component({
  selector: 'app-error-handling-version-two',
  templateUrl: './error-handling.component.html',
  styleUrls: ['./error-handling.component.scss']
})
export class ErrorHandlingComponent implements OnInit {

  private mobile: boolean;
  public error: Error;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private paymentService: PaymentService,
    private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe(
      Breakpoints.HandsetPortrait
    ).subscribe(result => this.mobile = result.matches);
    this.error = {
      error:"Error Occured",
      errorDescription:"Transaction cannot be completed at the moment."
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params:Params)=>{
      this.error = {
        error:params['subject'],
        errorDescription:params['message'],
      }
    });
  }

}
